module.exports = __webpack_public_path__ + "a4863f1adfbf6ab38fe6605e989caa10.pdf";